module.exports = __webpack_public_path__ + "img/niahr.eb7f583b.png";